import { useTranslation } from 'react-i18next';
import { FC, useRef, useState } from 'react';
import { SVGAssets } from '@business/assets/vectors';
import { useOutsideClickHandler } from '@utils/hooks';
import { Button } from '../../Button';

interface PrivatePublicFilterProps {
  accessType: string;
  setFilterOptions: (options: any) => void;
}

export const PrivatePublicFilter: FC<PrivatePublicFilterProps> = ({
  accessType,
  setFilterOptions
}) => {
  const { t } = useTranslation();
  const [isAccessDropdownOpen, setIsAccessDropdownOpen] =
    useState<boolean>(false);
  const accessDropdownRef = useRef<HTMLDivElement | null>(null);

  useOutsideClickHandler(accessDropdownRef, () => {
    setIsAccessDropdownOpen(false);
  });

  return (
    <div className="relative" ref={accessDropdownRef}>
      <Button
        onClick={() => setIsAccessDropdownOpen(!isAccessDropdownOpen)}
        btnStyle="no-outline"
        className="px-3 py-2 text-sm bg-white text-gray-700 rounded-md focus:outline-none cursor-pointer  hover:bg-gray-50 flex items-center gap-2 min-w-[120px] justify-between">
        <div className="flex items-center gap-2">
          {accessType === 'private' ? (
            <SVGAssets.LockClosedIcon />
          ) : (
            <SVGAssets.LockOpen />
          )}
          <span>
            {accessType === 'public'
              ? t('photosPage.public')
              : t('photosPage.private')}
          </span>
        </div>
        <svg
          className={`w-4 h-4 transition-transform ${isAccessDropdownOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </Button>

      {isAccessDropdownOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border border-gray-200 z-50">
          <div className="py-1">
            <button
              onClick={() => {
                setFilterOptions((prev: any) => ({
                  ...prev,
                  accessType: 'public'
                }));
                setIsAccessDropdownOpen(false);
              }}
              className={`w-full px-4 py-2 text-sm text-left hover:bg-gray-50 flex items-center gap-2 ${
                accessType === 'public' ? 'bg-gray-50' : ''
              }`}>
              <SVGAssets.LockOpen />
              <span>{t('photosPage.public')}</span>
            </button>
            <button
              onClick={() => {
                setFilterOptions((prev: any) => ({
                  ...prev,
                  accessType: 'private'
                }));
                setIsAccessDropdownOpen(false);
              }}
              className={`w-full px-4 py-2 text-sm text-left hover:bg-gray-50 flex items-center gap-2 ${
                accessType === 'private' ? 'bg-gray-50' : ''
              }`}>
              <SVGAssets.LockClosedIcon />
              <span>{t('photosPage.private')}</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
